export enum RoleApplicationConfigurationRuleType {
  USER_ACCESS_LEVEL = 'USER_ACCESS_LEVEL',
  USER_DEPARTMENT_ID = 'USER_DEPARTMENT_ID',
  USER_SITE_ID = 'USER_SITE_ID',
  APPLIED_ROLE_ID = 'APPLIED_ROLE_ID',
  APPLIED_ROLE_NAME = 'APPLIED_ROLE_NAME'
}
